


































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';
import {
  PartnersApi, DocumentRequest, Partner, PartnerOnboarding, PartnerOnboardingStatusEnum, UserApi,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import ToastModule from '@/store/modules/toast';
import UserModule from '@/store/modules/user';
import Sidebar from '@/views/partners/sidebar.vue';
import PartnerStatusIcon from '@/components/PartnerStatusIcon/index.vue';
import StandardCard from '@/components/Card/StandardCard/index.vue';
import ScheduleSettingsPartner
  from '@/components/Form/Partner/ScheduleSettingsPartners/ScheduleSettingsPartner/index.vue';
import ScheduleSettingPartnersEdit
  from '@/components/Form/Partner/ScheduleSettingsPartners/ScheduleSettingPartnersEdit/index.vue';
import SelectionDropdown from '@/components/Form/SelectionDropdown/index.vue';
import AccountActivation from '@/components/AccountActivation/index.vue';
import PartnerUtil from '@/util/PartnerUtil';
import Service from '@/util/ServiceUtil';
import {
  IFwManagerInfo, IRestaurantUserInfo,
} from '@/interface/userTableInfo';

@Component({
  components: {
    Sidebar,
    PartnerStatusIcon,
    StandardCard,
    ScheduleSettingsPartner,
    SelectionDropdown,
    AccountActivation,
  },
  directives: { Sticky },
})
export default class ScheduleSettingsPartners extends Vue {
  public partner: Partner = {};

  public userStatus: any = '';

  public partnerStatus: string = 'inactive';

  public loading: boolean = false;

  public errors: string = '';

  public activationLoader: boolean = false;

  public saving: boolean = false;

  public restarantPartnerInfo: IRestaurantUserInfo = {
    restPartnerEmail: '',
    is: '',
  };

  public scoutUserInfo: IFwManagerInfo = {
    scoutUserEmail: '',
    is: '',
  }

  public mounted() {
    this.getPartnerByID();
  }

  public async getPartnerByID() {
    try {
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const { id } = this.$route.params;
          const api = new PartnersApi(AppModule.apiConfig);
          const partner: any = await api.getPartnerById(id);
          const { ownerUserId, scoutUserId } = partner.data;
          this.getPartnerUserInfo(ownerUserId as string, scoutUserId as string);
          this.partner = partner.data;
        } catch (err) {
          throw err;
        }
        const { onboarding }: any = this.partner;
        const { status } = onboarding;
        this.userStatus = PartnerUtil.getPartnerStatusColor(status as string);
        if (status === 'completed') {
          this.partnerStatus = this.partner.active ? 'active' : 'inactive';
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
  }

  public async getPartnerUserInfo(partnerUserID: string, scoutUserID: string) {
    const userApi = new UserApi(AppModule.apiConfig);
    const users = await Promise.all(
      [(userApi.getUser(partnerUserID)), (userApi.getUser(scoutUserID))],
    );
    const userInfo = !users || users.map((response) => response.data);
    if (userInfo) {
      const partnerUser = userInfo[0];
      const scoutUser = userInfo[1];
      const { email, is } = partnerUser;
      this.restarantPartnerInfo.is = is;
      this.restarantPartnerInfo.restPartnerEmail = email as string;
      this.scoutUserInfo.scoutUserEmail = scoutUser.email as string;
      this.scoutUserInfo.is = scoutUser.is;
    }
    return null;
  }

  public async onUpdateStatus(status: string) {
    try {
      this.loading = true;
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const { id } = this.$route.params;
          const state = status === 'active';
          const userState: any = {
            active: state,
          };
          if (this.userStatus.status === 'Approved') {
            const api = new PartnersApi(AppModule.apiConfig);
            const partnerState: any = await api.patchPartnerById(id, userState);
            if (partnerState.status === 200) {
              ToastModule.setToast({
                message: `${partnerState.data.name} has been changed successfully`,
                timeout: 5000,
              });
            }
          }
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  public async sendInvitation(userEmail: string, userProfile: string) {
    if (userProfile === 'restPartner') {
      this.activationLoader = true;
    }
    if (userProfile === 'fwmanager') {
      this.saving = true;
    }
    const user: any = await Service.sendInvitation(userEmail);
    if (user.status === 200) {
      ToastModule.setToast({
        message: 'Sign up invitation has been sent',
        timeout: 5000,
      });
    } else {
      ToastModule.setToast({
        message: user.errorMessage,
        timeout: 5000,
      });
    }
    if (userProfile === 'restPartner') {
      this.activationLoader = false;
    }
    this.saving = false;
  }

  get adminUser() {
    if (UserModule.currentRole === 'fw_admin'
    || UserModule.currentRole === 'fw_manager'
    ) {
      return UserModule.currentRole;
    }
    return null;
  }
}
